import React, { useState, useEffect } from "react";
import ApiRequest from "../ApiRequest";
import { StyledButton, StyledBox, StyledTypo, StyledPaper } from "../StyledMui";
import { TextField, TablePagination, Radio, Paper, InputLabel, MenuItem, FormControl, Select, ToggleButton, ToggleButtonGroup, FormGroup, FormControlLabel, Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Stack, Divider, OutlinedInput, InputAdornment } from "@mui/material";
import useStore from "../Store";
import { useAlert } from "../AlertProvider";
import SearchIcon from "@mui/icons-material/Search";

function Nav(props) {
  const [type, setType] = useState("alimtalk");
  const { getTemplates, templates, selectedTemplate, setSelectedTemplate, channels, getChannels, selectedChannel, setSelectedChannel, selectedChannelName, selectedPhone, setSelectedPhone, setSelectedChannelName, org, isMMS, setIsMMS, isAd, setIsAd } = useStore((state) => state.header);
  const { initData, getTemplate, getChannel } = useStore((state) => state.mapper);
  const { setIsVar, setVariableSwitchFlag, setPhoneMessageSwitchFlag } = useStore((state) => state.preview);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [searchKeyword, setSearchKeyword] = useState("");
  const { showAlert } = useAlert();

  useEffect(() => {
    getTemplates();
    getChannels();
  }, []);

  useEffect(() => {
    if (org && Object.keys(org).length > 0) getChannels();
  }, [org]);

  useEffect(() => {
    if (initData && Object.keys(initData).length > 0) {
      console.log(initData);
      if (initData.templateId) getTemplate(initData.templateId);
      if (initData.channelCode) getChannel(initData.channelCode);
      if (initData.ismms) setIsMMS(initData.ismms);
      if (initData.adFlag) setIsAd(initData.adFlag);
      if (initData.templateType) setType(initData.templateType);
      if (initData.validationError) showAlert(initData.validationError, "error", 0);
    }
  }, [initData]);

  useEffect(() => {
    setIsVar(false);
    setVariableSwitchFlag(false);
    setPhoneMessageSwitchFlag(false);
    if (selectedTemplate.templateMessageType === "FC" || selectedTemplate.templateMessageType === "FL") {
      setIsAd(true);
    } else {
      setIsAd(false);
    }
  }, [selectedTemplate]);

  const filteredTemplates = templates.filter((template) => template.channelName === selectedChannelName && (type === "all" || template.templateType === type)).filter((template) => template.templateCode.toLowerCase().includes(searchKeyword.toLowerCase()) || template.templateName.toLowerCase().includes(searchKeyword.toLowerCase()));
  const totalPages = Math.ceil(filteredTemplates.length / itemsPerPage);
  const currentTemplates = filteredTemplates.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0); // Reset current page when changing items per page
  };

  const handleSearchKeywordChange = (event) => {
    setSearchKeyword(event.target.value);
  };

  const handleChannelChange = (event) => {
    const channelName = event.target.value;
    setSelectedChannelName(channelName);

    const selectedChannelObject = channels.find((channel) => channel.channelName === channelName);
    console.log(selectedChannelObject);
    if (selectedChannelObject) {
      setSelectedChannel(selectedChannelObject);
      setSelectedPhone(selectedChannelObject.channelPhone);
    }
    setCurrentPage(0);
  };

  const handleClickType = (event) => {
    setType(event.target.value);
    setCurrentPage(0);
  };

  return (
    <StyledPaper style={{ height: "100%" }}>
      <StyledBox>
        <StyledTypo>채널 선택</StyledTypo>
      </StyledBox>
      <Stack direction="column">
        <FormControl variant="standard" sx={{ width: "100%", margin: "5px", bgcolor: "white" }}>
          <InputLabel sx={{ transform: "none" }} id="c-name">
            채널명
          </InputLabel>
          <Select labelId="c-name" id="c-name" label="채널명" value={selectedChannelName} onChange={handleChannelChange} sx={{ height: 50 }}>
            {channels.map((channel, index) => (
              <MenuItem key={index} value={channel.channelName} name={index}>
                {channel.channelName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="standard" sx={{ width: "100%", margin: "5px" }}>
          <InputLabel sx={{ transform: "none" }} id="p-number">
            발신번호
          </InputLabel>
          <TextField
            id="p-number"
            value={selectedPhone}
            InputProps={{
              readOnly: true,
              disableUnderline: false,
            }}
            variant="standard"
            sx={{ height: 50, marginTop: "1.5rem" }}
          />
        </FormControl>
      </Stack>
      <FormGroup sx={{ flexDirection: "row", justifyContent: "flex-end" }}>
        <FormControlLabel disabled={!selectedChannelName || (selectedTemplate && selectedTemplate.mmsAttach && !JSON.parse(selectedTemplate.mmsAttach)?.subject)} checked={isMMS} onChange={(event) => setIsMMS(event.target.checked)} control={<Checkbox />} label="전송실패 시 MMS 발송" />
        {selectedTemplate && selectedTemplate.templateType === "friendtalk" && <FormControlLabel disabled={selectedTemplate.templateMessageType === "FC" || selectedTemplate.templateMessageType === "FL"} checked={isAd} onChange={(event) => setIsAd(event.target.checked)} control={<Checkbox />} label="광고메세지 발송" />}
      </FormGroup>
      <Divider />
      <br />
      <StyledBox>
        <StyledTypo>템플릿 선택</StyledTypo>
        <ToggleButtonGroup
          color="primary"
          exclusive
          onChange={handleClickType}
          value={type}
          sx={{
            alignSelf: "flex-end",
            height: "32px",
            overflow: "hidden",
          }}>
          <ToggleButton value="alimtalk">알림톡</ToggleButton>
          <ToggleButton value="friendtalk">친구톡</ToggleButton>
        </ToggleButtonGroup>
      </StyledBox>

      <Stack direction="row" alignItems="center">
        <OutlinedInput sx={{ flexGrow: 1, height: "38px" }} placeholder="검색" startAdornment={<InputAdornment position="start">{<SearchIcon fontSize="small" />}</InputAdornment>} onChange={handleSearchKeywordChange} />{" "}
      </Stack>
      <TableContainer component={Paper}>
        <Table sx={{ Width: "100%" }} size="small">
          <TableHead>
            <TableRow>
              <TableCell>선택</TableCell>
              <TableCell>템플릿 코드</TableCell>
              <TableCell>템플릿명</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentTemplates.length ? (
              currentTemplates.map((template, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Radio size="sm" checked={selectedTemplate.Id === template.Id} onChange={() => setSelectedTemplate(template)}>
                      선택
                    </Radio>
                  </TableCell>
                  <TableCell>{template.templateCode}</TableCell>
                  <TableCell>{template.templateName}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3}>No templates available.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination component="div" rowsPerPageOptions={[5, 7, 10]} count={filteredTemplates.length} page={currentPage} onPageChange={handlePageChange} rowsPerPage={itemsPerPage} onRowsPerPageChange={handleItemsPerPageChange} />
      </TableContainer>
      <br />
      <Divider />
      <br />
      <StyledBox>
        <StyledTypo>템플릿 버튼</StyledTypo>
      </StyledBox>
      <TableContainer component={Paper}>
        <Table sx={{ Width: "100%" }} size="small">
          <TableHead>
            <TableRow>
              {selectedTemplate && selectedTemplate.templateMessageType === "FC" && <TableCell>캐로샐순서</TableCell>}

              <TableCell>버튼유형</TableCell>
              <TableCell>버튼명</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {selectedTemplate && selectedTemplate.buttons ? (
              JSON.parse(selectedTemplate.buttons).map((buttonGroup, groupIndex) =>
                buttonGroup.map((button, buttonIndex) => (
                  <TableRow key={`${groupIndex}-${buttonIndex}`}>
                    {selectedTemplate && selectedTemplate.templateMessageType === "FC" && <TableCell>{groupIndex + 1}</TableCell>}
                    <TableCell>{button.linkType}</TableCell>
                    <TableCell>{button.name}</TableCell>
                  </TableRow>
                ))
              )
            ) : (
              <TableRow>
                <TableCell style={{ textAlign: "center" }} colSpan={2}>
                  템플릿을 먼저 선택해주세요
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Divider />
      <br />
      {selectedTemplate && selectedTemplate.templateType === "alimtalk" && (
        <>
          <StyledBox>
            <StyledTypo>템플릿 바로연결 버튼</StyledTypo>
          </StyledBox>
          <TableContainer component={Paper}>
            <Table sx={{ Width: "100%" }} size="small">
              <TableHead>
                <TableRow>
                  <TableCell>버튼유형</TableCell>
                  <TableCell>버튼명</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedTemplate && selectedTemplate.quickReplies ? (
                  JSON.parse(selectedTemplate.quickReplies)?.map((quickReply, index) => (
                    <TableRow key={index}>
                      <TableCell>{quickReply.linkType}</TableCell>
                      <TableCell>{quickReply.name}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell style={{ textAlign: "center" }} colSpan={2}>
                      템플릿을 먼저 선택해주세요
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <br />
          <Divider />
        </>
      )}

      <br />
      <StyledBox component="div">
        <StyledTypo>템플릿 이미지</StyledTypo>
      </StyledBox>
      <TableContainer component={Paper}>
        <Table sx={{ Width: "100%" }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>이름</TableCell>
              <TableCell>URL</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.keys(selectedTemplate).length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} style={{ textAlign: "center" }}>
                  템플릿을 먼저 선택해주세요
                </TableCell>
              </TableRow>
            ) : (
              <TableRow>
                <TableCell style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{selectedTemplate?.templateImageName}</TableCell>
                <TableCell style={{ maxWidth: 200, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {selectedTemplate &&
                    selectedTemplate.templateImageUrl &&
                    JSON.parse(selectedTemplate.templateImageUrl).map((imageUrl, index) => (
                      <>
                        <a key={index} target="_blank" href={imageUrl}>
                          {imageUrl}
                        </a>
                        <br />
                      </>
                    ))}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </StyledPaper>
  );
}

export default Nav;
